import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { openWhatsApp } from "@/lib/whatsapp";

const POINTS = [
  "Il bambino resta a casa, con il genitore accanto",
  "L’infermiere usa otoscopio e stetoscopio TytoCare",
  "Il pediatra guida l’esame in diretta",
  "Gola, orecchie e polmoni controllati con calma",
];

export default function PediatricsSection() {
  return (
    <section id="pediatria" className="bg-white py-20 sm:py-28" data-testid="pediatrics-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10 items-center">
          {/* Copy */}
          <div className="lg:col-span-6 order-2 lg:order-1">
            <motion.span
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="inline-flex items-center gap-2 rounded-full bg-[#FF7EB3]/12 px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-[#D14B87]"
            >
              <span className="h-2 w-2 rounded-full bg-[#FF7EB3]" />
              Pediatria
            </motion.span>
            <motion.h2
              initial={{ opacity: 0, y: 22 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className="font-heading mt-5 text-3xl sm:text-4xl lg:text-[2.6rem] font-medium leading-tight tracking-tight text-[#1F152E]"
              data-testid="pediatrics-title"
            >
              Il pediatra controlla gola, orecchie e polmoni senza far uscire il bambino di casa
            </motion.h2>

            <motion.ul
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="mt-7 space-y-3"
            >
              {POINTS.map((p) => (
                <li key={p} className="flex items-start gap-3 text-[15px] text-[#3B2F4C]">
                  <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#D4F84A]">
                    <Check className="h-3.5 w-3.5 text-[#1F152E]" strokeWidth={3} />
                  </span>
                  {p}
                </li>
              ))}
            </motion.ul>

            <motion.button
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2 }}
              onClick={() => openWhatsApp("Buongiorno, vorrei ricevere maggiori informazioni sul servizio TytoCare per le visite pediatriche assistite a domicilio.")}
              className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-[#5B2C91] px-7 py-4 text-base font-semibold text-white shadow-[0_16px_40px_rgba(91,44,145,0.28)] hover:bg-[#4A2277] hover:-translate-y-0.5 transition-[transform,background-color] duration-200"
              data-testid="pediatrics-cta"
            >
              <FaWhatsapp className="h-5 w-5" />
              Verifica un pediatra disponibile
            </motion.button>
          </div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="lg:col-span-6 order-1 lg:order-2"
          >
            <div className="overflow-hidden rounded-[2rem] lg:rounded-[2.5rem] bg-[#F4F2F9] shadow-[0_30px_80px_rgba(91,44,145,0.18)] ring-1 ring-white/60">
              <img
                src="/generated/pediatria-scene.png"
                alt="Infermiere effettua una visita pediatrica assistita a domicilio con TytoCare mentre il pediatra si collega in diretta sul tablet"
                className="w-full h-[360px] sm:h-[480px] lg:h-[560px] object-cover"
                data-testid="pediatrics-image"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
